module.exports = __webpack_public_path__ + "img/stop.b9c44e3d.png";